<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kBsN4z/tc-custom/9780802199515.jpg?1697143674438" alt="This image is the cover for the book Devil Tree"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Devil Tree
      </h1>
      <p class="bookDescription body article font2">
        <b>Kosinski’s classic, acclaimed as “an impressive novel . . . should confirm [his] position as one of our most significant writers” (<i>Newsweek</i>).</b><br/>  <br/> A searing novel from a writer of international stature, <i>The Devil Tree</i> is a tale that combines the existential emptiness of Camus’s <i>The Stranger</i> with the universe of international playboys, violence, and murder of Patricia Highsmith’s <i>The Talented Mr. Ripley</i>.<br/>  <br/> Jonathan Whalen’s life has been determined from the start by the immense fortune of his father, a steel tycoon. Whalen’s childlike delight in power and status mask a greater need, a desire to feel life intensely, through drugs, violence, sex, and attempts at meaningful connection with other people—whether lovers or the memory of his dead parents. But the physical is all that feels real to him, and as he embarks on a journey to Africa with his godparents, Whalen’s embrace of amoral thrill accelerates toward ultimate fulfillment.<br/>  <br/> “Savage . . . [Whalen is] a foolproof, timeless American character.” —<i>Cosmopolitan</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerzy Kosinski
      </h2>
      
      <p class="authorDescription body article">Jerzy Kosinski (1933&ndash;1991) won the Academy of Arts and Letters Award in Literature (1970), National Book Award for <I>Steps&#160;</I>(1969), best Screenplay of the Year Award for &quot;Being There&quot; from the Writers Guild of America (1980) as well as the British Academy of Film and Television Arts (BAFTA; 1981). In 1967, he was a Guggenheim fellow. This just names a few of his many achievements.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      GROVE PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cfb35204